import styled from 'styled-components';

export const Container = styled.div`
  grid-area: SH;
  padding: 30px;

  @media(max-width: 768px) {
    padding: 15px 30px;
  }
`;
